import React from "react";
import { servicios } from "../properties.js";

export default class CintilloNuevo  extends React.Component {
    onClose = e => { 
        this.props.onClose && this.props.onClose (e); 
     }; 
    render() {
    if(!this.props.show){
        return null;
    }
    const dominio = servicios.dominioReingenieria + "login"
  return <div className="content-padre-msjTooltip" id="tooltip">
        <div className={"msjTooltip-content"} 
            style={{background:'#E7F2FC', color:'#567EAD'}}>
            <div className="icono-sintillo-content">
                {
                <span className="icon-informativo-circulo"></span> 
                }
            </div>
            <div className="content-texto">
                <p>{this.props.titulo}</p>
                <label>Este portal ha sido renovado para que vivas una nueva experiencia, por lo que te invitamos a disfrutarlo. 
                    Accede a él ahora mismo dando clic <strong><a href={dominio}>aquí</a></strong>.</label>
            </div>
            <span className="material-icons icono-cerrar-sintillo" onClick={this.onClose}><a href={dominio}>close</a></span>
        </div>
      </div>
  }
}


// WEBPACK FOOTER //
// ./src/mensajes-tooltips/mensaje-nuevoportal.cmpt.js